import * as R from 'ramda'
import coact from 'coact'
import { configure } from 'coact/react-hotkeys'

import models from './models/client.js'
import menu from './menu.js'

// My Components
import StocksEditor from './components/StocksEditor/index.js'
import StocksList from './components/StocksList/index.js'
import UploadTemplate from './components/UploadTemplate/index.js'
import ShoplineStocks from './components/ShoplineStocks/index.js'

import editStocks from './sagas/editStocks.js'

import SalesOrderCreator from './components/SalesOrderCreator/index.js'
import salesOrderCreatorSaga from './components/SalesOrderCreator/salesOrderCreatorSaga.js'

import installProduct from './product/installClient.js'
import installPurchase from './purchase/installClient.js'
import installInvoice from './invoice/installClient.js'
import installPos from './pos/installClient.js'
import installStaffer from './staffer/installClient.js'
import installConsumers from './consumers/installClient.js'
import installStock from './stock/installClient.js'
import installStockScanner from './stock-scanner/installClient.js'

const config = {
  title: 'Hehong App',
  models,
  routes: {
    stocksEditor: {
      title: '庫存盤點',
      path: '/route/stocksEditor',
      component: StocksEditor,
    },
    deliveryProcess: {
      title: '客戶訂單出貨處理',
      path: '/route/deliveryProcess',
      component: SalesOrderCreator,
    },
    stocksList: {
      title: '庫存列表',
      path: '/route/stocksList',
      component: StocksList,
      authChecker: authority =>
        R.path(['routes', 'publicProducts'], authority) &&
        R.path(['routes', 'publicStocks'], authority),
    },
    uploadTemplate: {
      title: '上傳 Template',
      path: '/route/uploadTemplate',
      component: UploadTemplate,
    },
    shoplineStocks: {
      title: 'Shopline 資料同步',
      path: '/route/shoplineStocks',
      component: ShoplineStocks,
    },
  },
  menu,
  sagas: {
    editStocks,
    salesOrderCreatorSaga,
  },
}

const fullConfig = R.pipe(
  installProduct,
  installPurchase,
  installInvoice,
  installPos,
  installStaffer,
  installConsumers,
  installStockScanner,
  installStock,
)(config)

// ENTER IN A FILTER FIELD, and every other hotkey bound behind an input.
// react-hotkeys 2 ignores key events coming from input/select/textarea, and the
// coact upgrade brought it up from 1.1.4: v1 bound a Mousetrap instance to the
// HotKeys element and Mousetrap never stops for an event inside its own target,
// so a nested field was fine. v2 dropped Mousetrap and checks the tag name
// alone, however deeply nested, which silently killed the list page's
// Enter-to-filter, ProductReader's Enter-to-scan and the ctrl+enter on every
// edit page.
//
// Emptying the list restores all three and costs nothing: every other hotkey
// coact declares is a modifier combo, so no bare key starts firing mid-typing.
// Belongs upstream in coact, which owns those components; this reaches the same
// module either way, there being one react-hotkeys in the tree.
configure({ ignoreTags: [] })

coact(fullConfig)
